.button {
  margin-right: 10px;
}

.center {
  text-align: center;
}